module.exports = __webpack_public_path__ + "img/weixiu_fwsrz.b9bdd93b.png";